/* PageFlow canvas: loaded inside the editing iframe, after the styles of the site. */
:root {
    --pf-a: #6d5efc;
    --pf-a-soft: rgba(109, 94, 252, .1);
    --pf-row: #ec4899;
    --pf-col: #3b82f6;
    --pf-ink: #1e1b3a;
}
html { scroll-behavior: auto !important; }
body.pf-canvas-body { margin: 0; min-height: 100vh; }
/* Room above the first block for its label and toolbars, and below the last one to drop after it. */
.pf-root { min-height: 100vh; padding-top: calc(48px * var(--pf-k, 1)); padding-bottom: 96px; }
.pf-preview .pf-root { padding-top: 0; padding-bottom: 0; }
.pf-root::after { content: ""; display: table; clear: both; }

/* Guides of the structure (button "outlines" of the top bar), as in PageFlow 1.x: each container,
   row and column gets a little room, a colored outline and its name. The room is a transparent border,
   added to the element's own spacing (never replacing its classes); the preview shows the real layout.
   A label is placed from the inside of that border: its offsets bring it back onto the dashed outline. */
:root { --pf-container: #22a565; --pf-box: #8b7dff; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="container"],
body:not(.pf-no-guides):not(.pf-preview) [data-pf="row"],
body:not(.pf-no-guides):not(.pf-preview) [data-pf="col"],
body:not(.pf-no-guides):not(.pf-preview) [data-pf="box"] { position: relative; outline-offset: -1px; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="container"] { outline: 1.5px dashed color-mix(in srgb, var(--pf-container) 65%, transparent); border: 10px solid transparent !important; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="box"] { outline: 1.5px dashed color-mix(in srgb, var(--pf-box) 65%, transparent); }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="row"] { outline: 1.5px dashed color-mix(in srgb, var(--pf-row) 60%, transparent); border-top: 12px solid transparent !important; border-bottom: 12px solid transparent !important; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="col"] { outline: 1.5px dashed color-mix(in srgb, var(--pf-col) 60%, transparent); outline-offset: -3px; border-top: 8px solid transparent !important; border-bottom: 8px solid transparent !important; min-height: 64px; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="container"]::after,
body:not(.pf-no-guides):not(.pf-preview) [data-pf="row"]::after,
body:not(.pf-no-guides):not(.pf-preview) [data-pf="col"]::after,
body:not(.pf-no-guides):not(.pf-preview) [data-pf="box"]::after {
    position: absolute;
    right: 6px;
    bottom: -1px;
    z-index: 5;
    padding: 1px 6px 2px;
    border-radius: 4px 4px 0 0;
    color: #fff;
    font: 600 10px/1.3 system-ui, -apple-system, "Segoe UI", sans-serif;
    letter-spacing: .03em;
    opacity: .75;
    pointer-events: none;
    transform: scale(var(--pf-k, 1));
    transform-origin: 100% 100%;
}
body:not(.pf-no-guides):not(.pf-preview) [data-pf="container"]::after { content: "container"; background: var(--pf-container); bottom: -10px; right: -4px; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="row"]::after { content: "row"; background: var(--pf-row); bottom: -12px; right: 70px; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="col"]::after { content: "col"; background: var(--pf-col); bottom: -6px; right: 6px; }
body:not(.pf-no-guides):not(.pf-preview) [data-pf="box"]::after { content: "box"; background: var(--pf-box); }
body:not(.pf-no-guides):not(.pf-preview) [data-pf]:hover::after { opacity: 1; }

/* Empty blocks keep a size to drop into. */
body:not(.pf-preview) [data-pf="col"]:empty,
body:not(.pf-preview) [data-pf="container"]:empty,
body:not(.pf-preview) [data-pf="box"]:empty {
    min-height: 96px;
    background: repeating-linear-gradient(-45deg, rgba(109, 94, 252, .05) 0 8px, transparent 8px 16px);
    position: relative;
}
body:not(.pf-preview) [data-pf="col"]:empty::before,
body:not(.pf-preview) [data-pf="container"]:empty::before,
body:not(.pf-preview) [data-pf="box"]:empty::before {
    content: "+";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 28px;
    height: 28px;
    margin: -14px 0 0 -14px;
    border-radius: 50%;
    border: 1.5px dashed rgba(109, 94, 252, .55);
    color: rgba(109, 94, 252, .8);
    font: 400 20px/24px system-ui, sans-serif;
    text-align: center;
}
body:not(.pf-preview) [data-pf="row"]:empty { min-height: 60px; }

/* Content that would catch the clicks of the editor. */
body:not(.pf-preview) [data-pf] iframe,
body:not(.pf-preview) [data-pf] video,
body:not(.pf-preview) [data-pf] object { pointer-events: none; }
body:not(.pf-preview) [data-pf] a { cursor: default; }
[contenteditable] { outline: none; cursor: text !important; caret-color: var(--pf-a); }
[contenteditable]:empty::before { content: "\200b"; }
body:not(.pf-preview) [data-pf-edit] { cursor: text; }

/* Media waiting for a file. */
body:not(.pf-preview) img[src=""],
body:not(.pf-preview) img:not([src]) {
    display: block;
    width: 100%;
    min-height: 180px;
    background: #ecebf6 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath fill='%23a7a2d6' d='M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16Zm0 16v102.75l-26.07-26.06a16 16 0 0 0-22.63 0l-20 20-44-44a16 16 0 0 0-22.62 0L40 149.37V56Zm-60 44a12 12 0 1 1 12 12 12 12 0 0 1-12-12Z'/%3E%3C/svg%3E") center / 64px no-repeat;
    border-radius: 8px;
}
body:not(.pf-preview) [data-pf="video"] video:not([src]):not(:has(source)) {
    display: block;
    width: 100%;
    min-height: 220px;
    background: #1e1b3a url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath fill='%23ffffff' opacity='.6' d='M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm36.44 110.66-48 32A8.05 8.05 0 0 1 112 168a8 8 0 0 1-8-8V96a8 8 0 0 1 12.44-6.66l48 32a8 8 0 0 1 0 13.32Z'/%3E%3C/svg%3E") center / 72px no-repeat;
    border-radius: 8px;
}
body:not(.pf-preview) [data-pf="embed"] iframe:not([src]),
body:not(.pf-preview) [data-pf="embed"] iframe[src=""] { background: #ecebf6; }
body:not(.pf-preview) [data-pf="spacer"] { background: repeating-linear-gradient(45deg, rgba(109, 94, 252, .08) 0 6px, transparent 6px 12px); }
[data-pf-wrapper] { padding: 6px 0; }
[data-pf-wrapper] > hr { margin: 0; }
.pf-dragging { opacity: .3; }
/* A file being uploaded into a block. */
[data-pf-uploading] { position: relative; }
[data-pf-uploading]::before { content: ""; position: absolute; inset: 0; z-index: 6; border-radius: inherit; background: rgba(255, 255, 255, .55); }
[data-pf-uploading]::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 7;
    width: 38px;
    height: 38px;
    margin: -19px 0 0 -19px;
    border: 3px solid rgba(109, 94, 252, .25);
    border-top-color: #6d5efc;
    border-radius: 50%;
    animation: pf-spin .8s linear infinite;
}
@keyframes pf-spin { to { transform: rotate(360deg); } }
.pf-is-dragging, .pf-is-dragging * { cursor: grabbing !important; user-select: none !important; }

/* ---- Interface layer (never exported) ---- */
.pf-ui { position: fixed; inset: 0; pointer-events: none; z-index: 2147483000; }
.pf-preview .pf-ui > :not(.pf-ui-rte) { display: none !important; }
.pf-ui, .pf-ui * { box-sizing: border-box; font: 500 12px/1.2 system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; letter-spacing: normal; text-transform: none; }
.pf-ui-box { position: absolute; top: 0; left: 0; display: none; pointer-events: none; border-radius: 3px; will-change: transform; }
.pf-ui-hover { outline: 1px solid var(--pf-a); outline-offset: -1px; }
.pf-ui-select { outline: 2px solid var(--pf-a); outline-offset: -1px; }
.pf-ui-box[data-kind="row"] { --pf-a: var(--pf-row); }
.pf-ui-box[data-kind="col"] { --pf-a: var(--pf-col); }
.pf-ui-box[data-block="container"] { --pf-a: var(--pf-container); }
.pf-ui-select.pf-ui-editing { outline-style: dashed; outline-width: 1px; }
.pf-ui-select.pf-ui-editing .pf-ui-label { display: none; } /* the text toolbar takes its place */
.pf-ui-label {
    transform: scale(var(--pf-k, 1));
    transform-origin: 0 100%;
    position: absolute;
    left: -1px;
    bottom: 100%;
    padding: 3px 7px;
    border-radius: 4px 4px 0 0;
    background: var(--pf-a);
    color: #fff;
    font-size: 11px !important;
    white-space: nowrap;
}
.pf-ui-hover .pf-ui-label { background: #fff; color: var(--pf-a); box-shadow: 0 0 0 1px var(--pf-a) inset; }

.pf-ui-toolbar {
    position: absolute;
    transform-origin: 0 0;
    top: 0;
    left: 0;
    display: none;
    gap: 2px;
    padding: 3px;
    border-radius: 9px;
    background: var(--pf-ink);
    box-shadow: 0 6px 20px rgba(20, 16, 60, .3);
    pointer-events: auto;
}
.pf-ui-btn {
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #fff;
    cursor: pointer;
}
.pf-ui-btn:hover, .pf-ui-btn:focus-visible { background: rgba(255, 255, 255, .14); outline: none; }
.pf-ui-btn:disabled { opacity: .35; cursor: default; background: transparent; }
.pf-ui-btn.pf-on { background: var(--pf-a); }
.pf-ui-move { cursor: grab; touch-action: none; }
.pf-ui-danger:hover { background: #e5484d; }
.pf-ui-icon, .pf-ui-icon svg { display: block; width: 16px; height: 16px; }

.pf-ui-drop { position: absolute; top: 0; left: 0; display: none; border-radius: 4px; background: var(--pf-a); box-shadow: 0 0 0 3px rgba(109, 94, 252, .2); will-change: transform; }
.pf-ui-drop.pf-ui-drop-area { background: rgba(109, 94, 252, .12); box-shadow: none; outline: 2px dashed var(--pf-a); outline-offset: -2px; }

.pf-ui-handle { position: absolute; top: 0; left: 0; width: 10px; pointer-events: auto; cursor: col-resize; touch-action: none; }
.pf-ui-handle::after { content: ""; position: absolute; left: 3px; top: 50%; width: 4px; height: 44px; margin-top: -22px; border-radius: 4px; background: var(--pf-col); box-shadow: 0 0 0 2px #fff; }
.pf-ui-handle:hover::after, .pf-ui-handle.pf-active::after { height: 100%; top: 0; margin-top: 0; }
.pf-ui-tip { position: absolute; top: 0; left: 0; transform-origin: 0 0; padding: 4px 8px; border-radius: 6px; background: var(--pf-ink); color: #fff; white-space: nowrap; }

.pf-ui-empty { position: absolute; inset: 0; display: none; zoom: var(--pf-k, 1); flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 24px; text-align: center; color: var(--pf-ink); }
.pf-ui-empty-title { font-size: 22px !important; font-weight: 700 !important; }
.pf-ui-empty-text { font-size: 14px !important; font-weight: 400 !important; color: #6b6884; max-width: 420px; line-height: 1.5 !important; }
.pf-ui-empty-actions { display: flex; gap: 8px; margin-top: 8px; pointer-events: auto; flex-wrap: wrap; justify-content: center; }
.pf-ui-empty-btn { padding: 10px 16px; border: 0; border-radius: 8px; background: var(--pf-a); color: #fff; font-weight: 600 !important; font-size: 13px !important; cursor: pointer; }
.pf-ui-empty-btn-alt { background: #fff; color: var(--pf-a); box-shadow: 0 0 0 1px rgba(109, 94, 252, .4) inset; }

/* Text toolbar */
.pf-ui-rte {
    position: absolute;
    transform-origin: 0 0;
    top: 0;
    left: 0;
    display: none;
    align-items: center;
    gap: 1px;
    padding: 3px;
    border-radius: 9px;
    background: var(--pf-ink);
    box-shadow: 0 8px 24px rgba(20, 16, 60, .32);
    pointer-events: auto;
    max-width: calc(100vw - 8px);
    flex-wrap: wrap;
}
.pf-ui-sep { width: 1px; height: 18px; margin: 0 3px; background: rgba(255, 255, 255, .18); }
.pf-ui-select-format { height: 28px; padding: 0 6px; border: 0; border-radius: 6px; background: rgba(255, 255, 255, .1); color: #fff; cursor: pointer; }
.pf-ui-select-format option { color: #1e1b3a; background: #fff; }
.pf-ui-link {
    position: absolute;
    transform-origin: 0 0;
    top: 0;
    left: 0;
    display: none;
    flex-direction: column;
    gap: 8px;
    width: 300px;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    color: var(--pf-ink);
    box-shadow: 0 10px 30px rgba(20, 16, 60, .25), 0 0 0 1px rgba(20, 16, 60, .08);
    pointer-events: auto;
}
.pf-ui-input { width: 100%; height: 32px; padding: 0 8px; border: 1px solid #d9d6ec; border-radius: 6px; font-size: 13px !important; color: var(--pf-ink); background: #fff; }
.pf-ui-input:focus { outline: 2px solid var(--pf-a); outline-offset: -1px; border-color: transparent; }
.pf-ui-input.pf-invalid { border-color: #e5484d; outline-color: #e5484d; }
.pf-ui-check-label { display: flex; align-items: center; gap: 6px; font-weight: 400 !important; }
.pf-ui-link-actions { display: flex; gap: 6px; justify-content: flex-end; }
.pf-ui-text-btn { padding: 6px 10px; border: 0; border-radius: 6px; background: #f1f0f8; color: var(--pf-ink); cursor: pointer; }
.pf-ui-text-btn.pf-ui-primary { background: var(--pf-a); color: #fff; }
